import { Component, connect } from 'macguffin'
import ArrayHelper from "utils/ArrayHelper"
import { setPickItem, setPickStageComplete, addEmergencyFuel } from "game/redux/actions"

import BackgroundImage from "utils/BackgroundImage"

import Pick from "./Pick"

import { Tween } from "@tweenjs/tween.js"

const PICK_SCALE = 0.15
const PICK_RESULT_DURATION = 3000
const EMERGENCY_FUEL_DURATION = 3000

const AUTOPICK_TIMEOUT = 15 * 60 * 1000 //15 minute timeout

const pickDetailsStyle = {
	backgroundPosition: "center center"
}

const {...scanningBarStyle} = {
    backgroundRepeat: "repeat-x"
}

const pickHeaderStyle = {
	backgroundPosition: "center center"
}

const pickBackgroundAssets = [
	"pickStage1Background",
	"pickStage2Background",
	"pickStage3Background",
]

const pickBackgroundStyles = [
	{ backgroundPosition: "bottom center" },
	{ backgroundSize: "auto 30%", backgroundPosition: "center center" },
	{ backgroundPosition: "center bottom" }
]

const emergencyFuelStyle = {
	backgroundPosition: "center center"
}

const pickDetailAssets = [
	["pickStage1Pink", "pickStage1Green", "pickStage1Orange", "pickStage1Blue"],
	["pickStage2Pink", "pickStage2Green", "pickStage2Orange", "pickStage2Blue"],
	["pickStage3Pink", "pickStage3Green", "pickStage3Orange", "pickStage3Blue"]
]

const pickDetailStyles = [
	[
		{ width: "100%", height: "100%", backgroundSize: "30%", backgroundPosition: "7% 92%" },
        { width: "100%", height: "100%", backgroundSize: "28%", backgroundPosition: "32% 79%" },
        { width: "100%", height: "100%", backgroundSize: "35%", backgroundPosition: "60% 78%" },
        { width: "100%", height: "100%", backgroundSize: "32%", backgroundPosition: "90% 84%" }
	],
	[
		{ width: "100%", height: "100%", backgroundSize: "15%", backgroundPosition: "30% 35%" },
        { width: "100%", height: "100%", backgroundSize: "15%", backgroundPosition: "23% 62%" },
        { width: "100%", height: "100%", backgroundSize: "15%", backgroundPosition: "77% 33%" },
        { width: "100%", height: "100%", backgroundSize: "15%", backgroundPosition: "62% 62%" }
	],
	[
		{ width: "100%", height: "100%", backgroundSize: "10%", backgroundPosition: "35% 58%" },
        { width: "100%", height: "100%", backgroundSize: "10%", backgroundPosition: "12% 75%" },
        { width: "100%", height: "100%", backgroundSize: "10%", backgroundPosition: "85% 56%" },
        { width: "100%", height: "100%", backgroundSize: "10%", backgroundPosition: "72% 80%" }
	]
]

@connect(state => ({
	autoPick: state.base.settings.autoPick,
	currentPickStageIndex: state.game.currentPickStageIndex,
	currentPicksData: state.game.currentPicksData,
	pickIndex: state.game.pickIndex,
	currentPickResultData: state.game.currentPickResultData,
	globalPaused: state.base.paused
}), {
	setPickItem,
	setPickStageComplete,
	addEmergencyFuel
})

export default class PickStage extends Component {
	constructor() {
		super()
		this.state = {}
	}

	componentWillReceiveProps(newProps) {
		const { props: oldProps } = this
		const { autoPick, showPick, currentPickResultData, currentPickStageIndex } = newProps

		if (showPick && showPick !== oldProps.showPick) {
			this.timeout = new Tween()
				.to({}, AUTOPICK_TIMEOUT)
				.onComplete(() => {
					this.onSelect(Math.floor(Math.random() * 4))
				})
				.start()
		}

		if (!autoPick && autoPick !== oldProps.autoPick) {
			this.timeout && this.timeout.stop()
			this.timeout = undefined
		}

		if (currentPickStageIndex !== oldProps.currentPickStageIndex) {
			this.setState({ emergencyFuel: undefined })
		}

		if (currentPickResultData && currentPickResultData !== oldProps.currentPickResultData ) {
			this.setState({ selected: undefined })
		}
	}

	onSelect = (index) => {
		const { props: {setPickItem}, timeout } = this

		timeout && timeout.stop()
		this.timeout = undefined

		const callback = () => { setPickItem(index) }
		this.setState({ selected: index }, callback)
	}

	renderPickDetails = (index, style) => {
		if (!isNaN(index)) {
			return <div className="pickStageDetails" style={style}>
				<BackgroundImage assetName={pickDetailAssets[index][0]} style={pickDetailStyles[index][0]}/>
				<BackgroundImage assetName={pickDetailAssets[index][1]} style={pickDetailStyles[index][1]}/>
				<BackgroundImage assetName={pickDetailAssets[index][2]} style={pickDetailStyles[index][2]}/>
				<BackgroundImage assetName={pickDetailAssets[index][3]} style={pickDetailStyles[index][3]}/>
			</div>
		}
		return <div className="pickStageDetails" style={style}/>
	}

	render() {
		const { props, state, onSelect, renderPickDetails } = this
		const {
			currentPicksData,
			currentPickResultData,
			currentPickStageIndex,
			setPickItem,
			left,
			width,
			height,
			visibility,
			globalPaused
		} = props

		const { selected, emergencyFuel } = state

		const pickWidth = width * PICK_SCALE
		const pickHeight = height * PICK_SCALE

		const animationPlayState = globalPaused ? "paused" : "running"

		let pickStageDetailStyle = {}
		let picks
		if ( currentPickResultData ) {
			const mostRecentPickData = ArrayHelper(currentPickResultData).last()
        	picks = mostRecentPickData.picks.map((pick, index) => {
        		return <Pick key={index} index={index} data={pick} width={pickWidth} height={pickHeight}/>
        	})

        	pickStageDetailStyle.filter = "grayscale(100%)"
		} else if (currentPicksData) {
			picks = currentPicksData.map((pick, index) => {
				return <Pick
					key={index}
					index={index}
					width={pickWidth}
					height={pickHeight}
					onSelect={!selected && onSelect}
					selected={selected}
					paused={globalPaused}
				/>
			})
		}

		const style = {
			left,
			width: `${width}px`,
			height: `${height}px`,
			visibility,
			backgroundPosition: "center center"
		}

		if (!emergencyFuel) {
			return <BackgroundImage key="pickContainer" className="pickContainer" assetName="pickBackground" style={style}>
				<BackgroundImage key="pickDetails" className="pickDetails" assetName="pickFrame" style={pickDetailsStyle}>
					<BackgroundImage className="pickScanning" assetName="pickScanningBar" style={{...scanningBarStyle, animationPlayState}}/>
				</BackgroundImage>
				<BackgroundImage key="pickHeader" className="pickHeader" assetName="pickHeader" style={pickHeaderStyle}>
					<h1> {this.t(`pickstage.header${currentPickStageIndex + 1}`)} </h1>
				</BackgroundImage>
				<BackgroundImage className={`pickStage${currentPickStageIndex + 1}`} assetName={pickBackgroundAssets[currentPickStageIndex]} style={pickBackgroundStyles[currentPickStageIndex]}>
					{ renderPickDetails(currentPickStageIndex, pickStageDetailStyle) }
					{ picks }
				</BackgroundImage>
			</BackgroundImage>
		} else {
			return <BackgroundImage key="pickContainer" className="pickContainer" assetName="pickBackground" style={style}>
				<BackgroundImage key="pickDetails" className="pickDetails" assetName="pickFrame" style={pickDetailsStyle}>
					<BackgroundImage className="pickScanning" assetName="pickScanningBar" style={{...scanningBarStyle, animationPlayState}}/>
				</BackgroundImage>
				<BackgroundImage className="emergencyFuel" assetName="scatterSymbol" style={emergencyFuelStyle}/>
				<BackgroundImage key="pickHeader" className="pickHeader" assetName="pickHeader" style={pickHeaderStyle}>
					<h1> {this.t("pickstage.emergencyFuel")} </h1>
				</BackgroundImage>
			</BackgroundImage>
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const currentProps = this.props
		const { setPickStageComplete } = currentProps

		const { currentPickResultData } = currentProps

		if (currentPickResultData && currentPickResultData !== prevProps.currentPickResultData) {
			const mostRecentPickData = ArrayHelper(currentPickResultData).last()

			const finishTimeout = new Tween()
				.to({}, PICK_RESULT_DURATION)
				.onComplete(setPickStageComplete)

			if (mostRecentPickData.emergencyFuel) {
				new Tween()
					.to({}, EMERGENCY_FUEL_DURATION)
					.onComplete(() => {
						currentProps.addEmergencyFuel()
						this.setState({ emergencyFuel: true }, () => { finishTimeout.start() })
					})
					.start()
			} else {
				finishTimeout.start()
			}
		}
	}
}

